import { render, staticRenderFns } from "./PunctuationMarksPreview.vue?vue&type=template&id=67152162&lang=pug&"
import script from "./PunctuationMarksPreview.vue?vue&type=script&lang=js&"
export * from "./PunctuationMarksPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports